module.exports = __webpack_public_path__ + "img/network3.09d50070.png";